import React, {useEffect, useState} from 'react';
import {MaterialReactTable} from 'material-react-table';
import {$host} from "../http";
import {exportToExcel} from 'react-json-to-excel';
import {Box, Button, CircularProgress, Typography} from "@mui/material";
import {fetchAllPointsHistory} from "../http/userAPI";
import dayjs from "dayjs";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {MRT_Localization_RU} from "material-react-table/locales/ru";

const TABLE_CONFIG = {
    COMMON: {
        enableStickyHeader: true,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_RU,
        muiTableBodyRowProps: {
            sx: {
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.05)',
                },
            },
        },
        muiTablePaperProps: {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            },
        },
        muiTableContainerProps: {
            sx: {
                flex: 1,
                maxHeight: 'none',
                overflow: 'auto',
            },
        },
    },
};
export default function PointsHistory() {
    const [data, setData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({pageIndex: 0, pageSize: 25});
    const [sorting, setSorting] = useState([{id: 'createdAt', desc: true}]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [excelLoading, setExcelLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = async () => {
        setLoading(true);

        const query = {
            page: pagination.pageIndex + 1,
            limit: pagination.pageSize,
            sortBy: sorting[0]?.id,
            order: sorting[0]?.desc ? 'desc' : 'asc',
            search: globalFilter,
            ...Object.fromEntries(
                columnFilters.map(({id, value}) => [id, value])
            ),
        };
        const response = await $host.post('web/points_history', {params: query});

        setData(response.data.data);
        setRowCount(response.data.total);
        setLoading(false);
    };

    const handleExportExcel = async () => {
        setExcelLoading(true);
        try {
            const result = await fetchAllPointsHistory();
            exportToExcel(result.content || [], 'История баллов');
        } catch (err) {
            setError(err.message || 'Ошибка экспорта');
        } finally {
            setExcelLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [pagination, sorting, columnFilters, globalFilter]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
            <Box sx={{width: '100%', display: 'flex', flexDirection: 'column', gap: 2}}>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2}}>
                    <Typography variant="h6">
                        История баллов
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleExportExcel}
                        disabled={excelLoading}
                        sx={{height: 40, minHeight: 40, px: 2.5}}
                    >
                        {excelLoading ? <CircularProgress size={20} color="inherit"/> : 'Скачать Excel'}
                    </Button>
                </Box>
                <Box sx={{ height: 'calc(100vh - 220px)', minHeight: 360 }}>
                    <MaterialReactTable
                        {...TABLE_CONFIG.COMMON}
                        columns={[
                        {accessorKey: 'user.name', header: 'Имя пользователя'},
                        {accessorKey: 'user.phone', header: 'Телефон'},
                        {
                            accessorKey: 'transactionType', header: 'Тип транзакции',
                            filterVariant: 'select',
                            filterFn: 'equals',
                            filterSelectOptions: [
                                {text: 'Начисление', value: 'add'},
                                {text: 'Списание', value: 'withdraw'},
                            ],
                            Cell: ({cell}) => (cell.getValue() === 'add' ? 'Начисление' : 'Списание'),
                        },
                        {
                            accessorKey: 'pointsCount', header: 'Баллы',
                            filterFn: 'betweenInclusive',
                        },
                        {
                            accessorKey: 'createdAt',
                            accessorFn: (row) => new Date(row.createdAt),
                            header: 'Дата',
                            filterVariant: 'date-range',
                            Cell: ({cell}) => dayjs(cell.getValue()).format('DD.MM.YYYY HH:mm'),
                        },
                        {accessorKey: 'executor', header: 'Исполнитель'},
                        {accessorKey: 'comment', header: 'Комментарий'},
                    ]}
                        data={data}
                        manualPagination
                        manualSorting
                        manualFiltering
                        rowCount={rowCount}
                        state={{
                            isLoading: loading,
                            pagination,
                            sorting,
                            columnFilters,
                            globalFilter,
                        }}
                        onPaginationChange={setPagination}
                        onSortingChange={setSorting}
                        onColumnFiltersChange={setColumnFilters}
                        onGlobalFilterChange={setGlobalFilter}
                        initialState={{
                            density: 'compact',
                            showColumnFilters: true,
                        }}
                    />
                </Box>
                {
                    error && <div style={{color: 'red', marginTop: 8}}>{error}</div>
                }
            </Box>
        </LocalizationProvider>
    );
}
